import { authorizedRequest, getServiceData } from 'api';
import { getFirebaseIdToken } from 'api/firebase';
import jwtDecode from 'jwt-decode';

async function getUserToken(): Promise<any> {
  const firebaseToken = await getFirebaseIdToken();
  const response = await (
    await authorizedRequest('', true, {
      authorizeRequest: true,
      authorizeResponse: false,
      headers: {
        Authorization: `Bearer ${firebaseToken}`,
      },
    }).get('/auth/token')
  ).data;
  const { auth } = response as {
    auth: string;
  };
  const token = jwtDecode(auth);
  const data = getServiceData(token);
  if (!data) {
    localStorage.setItem('token', '');
    return null;
  }
  localStorage.setItem('token', auth);
  return token;
}

export default getUserToken;
